export const TERMS_OF_SERVICE = 'https://docs.rango.exchange/terms-of-use';
export const PRIVACY_POLICY = 'https://docs.rango.exchange/privacy-policy';
